import { connector } from "utils/common/connector";

const controller = "msg";

// ---------------------------------------------
// SEND SMS
// ---------------------------------------------
export const sendSMSService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "firstProvider", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};
